// Шаблоны текстов для согласия на обработку данных
// Файл: src/templates/dataProcessingTemplates.js

// Тексты для чекбокса согласия
export const consentCheckboxText = {
  uk: "Я погоджуюся на обробку моїх персональних даних відповідно до умов обробки даних",
  en: "I agree to the processing of my personal data according to the data processing terms",
  fr: "J'accepte le traitement de mes données personnelles conformément aux conditions de traitement des données"
};

// Тексты для маркетингового согласия
export const marketingConsentText = {
  uk: "Я погоджуюся отримувати маркетингові повідомлення від Syrnyk (необов'язково)",
  en: "I agree to receive marketing communications from Syrnyk (optional)",
  fr: "J'accepte de recevoir des communications marketing de Syrnyk (facultatif)"
};

// Тексты ошибок для обязательного согласия
export const requiredConsentError = {
  uk: "Ви повинні прийняти умови обробки даних для реєстрації",
  en: "You must accept the data processing terms to register",
  fr: "Vous devez accepter les conditions de traitement des données pour vous inscrire"
};

// Полные тексты соглашения об обработке данных
export const dataProcessingTermsTemplates = {
  uk: `# Угода про обробку даних

Відповідно до Федерального закону Швейцарії про захист даних (FADP/DSG), ми зобов'язуємося захищати ваші особисті дані.

## 1. Контролер даних
Syrnyk Ltd. є контролером даних, відповідальним за обробку ваших особистих даних.

## 2. Дані, які ми збираємо
Ми збираємо наступну інформацію:
- Особиста інформація (ім'я, електронна пошта, номер телефону)
- Адреси доставки та переваги
- Історія замовлень та інформація про оплату

## 3. Мета обробки даних
Ваші дані обробляються для:
- Управління обліковим записом
- Обробки та доставки замовлень
- Обслуговування клієнтів та комунікації
- Юридичних зобов'язань

## 4. Правова основа
Обробка базується на:
- Виконанні договірних зобов'язань
- Вашій згоді
- Наших законних ділових інтересах
- Дотриманні законодавчих вимог

## 5. Зберігання даних
Ваші дані надійно зберігаються в Швейцарії і будуть зберігатися стільки, скільки необхідно для описаних цілей або як того вимагає закон.

## 6. Ваші права
Ви маєте право:
- Отримати доступ до своїх особистих даних
- Вимагати виправлення неточних даних
- Вимагати видалення своїх даних
- Відкликати свою згоду в будь-який час
- Подати скаргу до Федерального комісара Швейцарії з захисту даних та інформації

## 7. Обмін даними
Ваші дані можуть бути передані:
- Постачальникам послуг доставки
- Обробникам платежів
- Постачальникам ІТ-послуг

## 8. Контактна інформація
З будь-яких питань щодо ваших даних, будь ласка, зв'яжіться з нами за адресою: privacy@syrnyk.ch

Позначаючи поле згоди, ви підтверджуєте, що прочитали та зрозуміли цю угоду та даєте згоду на обробку ваших особистих даних, як описано вище.`,

  en: `# Data Processing Agreement

According to the Swiss Federal Act on Data Protection (FADP/DSG), we are committed to protecting your personal data.

## 1. Data Controller
Syrnyk Ltd. is the data controller responsible for processing your personal data.

## 2. Data We Collect
We collect the following information:
- Personal information (name, email, phone number)
- Delivery addresses and preferences
- Order history and payment information

## 3. Purpose of Data Processing
Your data is processed for:
- Account management
- Order processing and delivery
- Customer service and communication
- Legal obligations

## 4. Legal Basis
The processing is based on:
- Fulfillment of contractual obligations
- Your consent
- Our legitimate business interests
- Compliance with legal requirements

## 5. Data Storage
Your data is stored securely in Switzerland and will be retained as long as necessary for the purposes described or as required by law.

## 6. Your Rights
You have the right to:
- Access your personal data
- Request correction of inaccurate data
- Request deletion of your data
- Withdraw your consent at any time
- Lodge a complaint with the Swiss Federal Data Protection and Information Commissioner

## 7. Data Sharing
Your data may be shared with:
- Delivery service providers
- Payment processors
- IT service providers

## 8. Contact Information
For any questions regarding your data, please contact us at: privacy@syrnyk.ch

By checking the consent box, you acknowledge that you have read and understood this agreement and consent to the processing of your personal data as described above.`,

  fr: `# Accord de Traitement des Données

Conformément à la Loi fédérale suisse sur la protection des données (LPD), nous nous engageons à protéger vos données personnelles.

## 1. Responsable du Traitement
Syrnyk Ltd. est le responsable du traitement de vos données personnelles.

## 2. Données que Nous Collectons
Nous collectons les informations suivantes:
- Informations personnelles (nom, email, numéro de téléphone)
- Adresses et préférences de livraison
- Historique des commandes et informations de paiement

## 3. Finalité du Traitement des Données
Vos données sont traitées pour:
- La gestion de compte
- Le traitement et la livraison des commandes
- Le service client et la communication
- Les obligations légales

## 4. Base Juridique
Le traitement est basé sur:
- L'exécution d'obligations contractuelles
- Votre consentement
- Nos intérêts commerciaux légitimes
- Le respect des exigences légales

## 5. Stockage des Données
Vos données sont stockées en toute sécurité en Suisse et seront conservées aussi longtemps que nécessaire aux fins décrites ou selon les exigences légales.

## 6. Vos Droits
Vous avez le droit de:
- Accéder à vos données personnelles
- Demander la correction de données inexactes
- Demander la suppression de vos données
- Retirer votre consentement à tout moment
- Déposer une plainte auprès du Préposé fédéral à la protection des données et à la transparence

## 7. Partage des Données
Vos données peuvent être partagées avec:
- Les fournisseurs de services de livraison
- Les processeurs de paiement
- Les fournisseurs de services informatiques

## 8. Coordonnées
Pour toute question concernant vos données, veuillez nous contacter à: privacy@syrnyk.ch

En cochant la case de consentement, vous reconnaissez avoir lu et compris cet accord et consentez au traitement de vos données personnelles tel que décrit ci-dessus.`
};

// Названия языков
export const languageNames = {
  uk: 'Українська',
  en: 'English',
  fr: 'Français'
};

// Интерфейсные тексты
export const uiTexts = {
  uk: {
    privacyTitle: 'Згода на обробку даних',
    termsLinkText: 'умови обробки даних',
    privacyNote: 'Ваші персональні дані обробляються відповідно до Федерального закону Швейцарії про захист даних (FADP/DSG).',
    modalTitle: 'Умови обробки даних',
    closeButton: 'Закрити',
    acceptButton: 'Прийняти умови',
    alreadyAccepted: 'Прийнято'
  },
  en: {
    privacyTitle: 'Data Processing Consent',
    termsLinkText: 'data processing terms',
    privacyNote: 'Your personal data is processed in accordance with the Swiss Federal Act on Data Protection (FADP/DSG).',
    modalTitle: 'Data Processing Terms',
    closeButton: 'Close',
    acceptButton: 'Accept Terms',
    alreadyAccepted: 'Accepted'
  },
  fr: {
    privacyTitle: 'Consentement au Traitement des Données',
    termsLinkText: 'conditions de traitement des données',
    privacyNote: 'Vos données personnelles sont traitées conformément à la Loi fédérale suisse sur la protection des données (LPD).',
    modalTitle: 'Conditions de Traitement des Données',
    closeButton: 'Fermer',
    acceptButton: 'Accepter les Conditions',
    alreadyAccepted: 'Accepté'
  }
};